import React from 'react';

const getDefaultSrc = (sex) => sex === 'common.male' ? '/images/male.png' : '/images/female.png';

const getPhotoSrc = (photo, fileType) => `data:image/${fileType};base64,${photo}`;

export const PersonPhoto = ({ photo, sex, fileType = 'jpeg' }) => {
    const src = photo ? getPhotoSrc(photo, fileType) : getDefaultSrc(sex);

    return (
        <div className="person-mask">
            <img src={src} alt="" />
        </div>
    );
};
